import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("导入")
const _hoisted_2 = { class: "scroll-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "上传的Excel表符合以下规范:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "● 文件大小不超过10M，且单个sheet页数据量不超过200行", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "● 仅支持(.xls和*.xlsx)文件", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "● 请确保您需要导入的sheet表头中不包含空的单元格，否则该sheet页数据系统将不做导入", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "● 批量导入的数据不支持以“内置变量”作为条件的过滤", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "● 导入文件不支持Excel公式计算，如SUM(A1:B3 A2:C2)等", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " ● 导入文件会覆盖已有往来单位信息，如需更新已有往来单位，请先导出数据，在导出表格里进行修改后再上传 ", -1)

import { ref, onMounted, computed, onUnmounted } from "vue";
import SelectFile from "./select-file.vue";
import DataPreview from "./data-preview.vue";
import DataValid from "./data-valid.vue";
import FinishImport from "./finish-import.vue";
import NP from "number-precision";
import { debounce } from "lodash";


import { defineComponent } from "vue";
const __default__ = defineComponent({
  isGlobal: true,
  name: "MultipleImport",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  checkApiFn: {
    type: Function,
    required: true,
  },
  uploadApiFn: {
    type: Function,
    required: true,
  },
  extraUploadApiFn: {
    type: Function,
  },
  backPage: {
    type: String,
    required: true,
  },
  modelUrl: {
    type: String,
  },
  columns: {
    type: Array,
    default: () => [],
  },
  templateKey:{
    type: String,
  },
  checkType: {
    type: String,
  },
  isExtraUploadApiFn:{
    type: Boolean,
    default:false
  }
},
  emits: ["refresh"],
  setup(__props, { emit }) {

const props = __props





const visible = ref(false);

const currentStep = ref(0);

const { run, data, loading } = props.checkApiFn();

const tableData = computed(() => {
  return {
    failList: data?.value?.failList?.slice(0, 100) || [],
    originalList:
      data?.value?.originalList?.slice(0, 100) || data?.value?.initialList?.slice(0, 100) || [],
    passList: data?.value?.passList?.slice(0, 100) || [],
    exportKey:data?.value?.exportKey
  };
});

async function finishUpload(url) {
  if (url && run) {
    const res = await run(url);
    if (res?.respCode === "0000") {
      currentStep.value = 1;
    }
  }
}

function setSteps(step: number) {
  currentStep.value = step;
  if (step === 3) {
    emit("refresh");
  }
}

const tableHeight = ref(200);
function calcTableHeight() {
  const doumentHeight = window.innerHeight > 1000 ? 1000 : window.innerHeight;

  const calcHeight = NP.minus(NP.times(doumentHeight, 0.8), 235);
  tableHeight.value = calcHeight > 200 ? calcHeight : 200;
}
onMounted(() => {
  calcTableHeight();
});

const deCalcTableHeight = debounce(calcTableHeight, 200);

window.addEventListener("resize", deCalcTableHeight);

function closeModal() {
  currentStep.value = 0;
  data && (data.value = undefined);
}

onUnmounted(() => {
  window.removeEventListener("resize", deCalcTableHeight);
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _hoisted_1
        ])
      ]),
      _: 3
    }),
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      class: "organization-import--modal",
      title: "导入数据",
      width: "65%",
      footer: false,
      "destroy-on-close": true,
      "after-close": closeModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_steps, { current: currentStep.value }, {
            default: _withCtx(() => [
              _createVNode(_component_a_step, { title: "选择EXCEL表" }),
              _createVNode(_component_a_step, { title: "数据预览" }),
              _createVNode(_component_a_step, { title: "导入校验" }),
              _createVNode(_component_a_step, { title: "导入数据" })
            ]),
            _: 1
          }, 8, ["current"]),
          (currentStep.value === 0)
            ? (_openBlock(), _createBlock(SelectFile, {
                key: 0,
                "loading-request": _unref(loading),
                "model-url": __props.modelUrl,
                templateKey: __props.templateKey,
                onFinishUpload: finishUpload
              }, {
                standard: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "limit", {}, () => [
                    _hoisted_3,
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7,
                    _hoisted_8,
                    _hoisted_9
                  ])
                ]),
                _: 3
              }, 8, ["loading-request", "model-url", "templateKey"]))
            : _createCommentVNode("", true),
          (currentStep.value === 1)
            ? (_openBlock(), _createBlock(DataPreview, {
                key: 1,
                data: _unref(tableData),
                columns: __props.columns,
                tableHeight: tableHeight.value,
                onSetSteps: setSteps
              }, null, 8, ["data", "columns", "tableHeight"]))
            : _createCommentVNode("", true),
          (currentStep.value === 2)
            ? (_openBlock(), _createBlock(DataValid, {
                key: 2,
                data: _unref(data),
                columns: __props.columns,
                tableHeight: tableHeight.value,
                "upload-api-fn": __props.uploadApiFn,
                isExtraUploadApiFn: __props.isExtraUploadApiFn,
                extraUploadApiFn: __props.extraUploadApiFn,
                onSetSteps: setSteps,
                checkType: __props.checkType,
                checkKey: _unref(tableData)?.exportKey
              }, null, 8, ["data", "columns", "tableHeight", "upload-api-fn", "isExtraUploadApiFn", "extraUploadApiFn", "checkType", "checkKey"]))
            : _createCommentVNode("", true),
          (currentStep.value === 3)
            ? (_openBlock(), _createBlock(FinishImport, {
                key: 3,
                "back-page": __props.backPage,
                onHandleClose: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
              }, null, 8, ["back-page"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 3
    }, 8, ["visible"])
  ], 64))
}
}

})